import { Routes } from '@angular/router';
import { AuthGuard } from "./core/services/auth-guard.service";
import { AuthenticationComponent } from "./core/components/authentication/authentication.component";
import { ProductionDataAdd, ProductionDataView, ProductLibraryCreate } from './modules/product-library';


export const routes: Routes = [

    {
        path: '',
        component: AuthenticationComponent,
    },
    {
        path: 'authentication',
        component: AuthenticationComponent,
    },
    // {
    //     path: 'product-development',
    //     loadComponent: () => import('./modules/index').then (com => com.ProductSampleGridComponent),
    //     canActivate: [AuthGuard]
    // },
    {
        path: 'product-development',
        loadChildren: () => import('./modules/product-devolopment').then(m => m.ProductDevelopmentModule),
        data: { title: 'Product Development' },
        // canActivate: [AuthGuard]

    },
    {
        path: 'home',
        loadComponent: () => import('./core/components/home/home.component').then(c => c.HomeComponent),
    },
    {
        path: 'task',
        loadComponent: () => import('./modules/task').then((com) => com.TaskDashboardComponent),
    },
    // {
    //     path: '',
    //     loadComponent: () => import('./modules/index').then(com => com.ProductLibraryView),
    //     // canActivate: [AuthGuard]
    // },
    // {
    //     path: '**',
    //     redirectTo: 'home'
    // },
    {
        path: 'product-library',
        loadComponent: () => import('./modules/index').then(com => com.ProductLibraryView),
        // canActivate: [AuthGuard]
    },
    {
        path: 'product-library-create',
        component: ProductLibraryCreate,
    },
    {
        path: 'prepress-jobentry',
        loadComponent: () => import('./modules/prepress-jobentry/prepress-jobentry.component').then(com => com.PrepressJobentryComponent),
    },
    {
        path: 'prepress-dashboard',
        loadComponent: () => import('./modules/prepress-jobentry/components/prepress-kanban-board/prepress-kanban-board.component').then(com => com.PrepressKanbanBoardComponent),
        data: { title: 'Pre-press Dashboard' },
    },
    {
        path: 'prepress-dashboard/analytics',
        loadComponent: () => import('./modules/prepress-jobentry/components/prepress-analytics/prepress-analytics.component').then(com => com.PrepressAnalyticsComponent),
        data: { title: 'Pre-press Analytics Dashboard' },
    },
    {
        path: 'prepress-analytics',
        redirectTo: 'prepress-dashboard/analytics',
        pathMatch: 'full'
    },
    {
        path: 'ink-kitchen',
        loadComponent: () => import('./modules/ink-kitchen').then(com => com.RecipeList),
        data: { title: 'Ink Kitchen' },
    },
    {
        path: 'ink-kitchen/recipes/create',
        loadComponent: () => import('./modules/ink-kitchen').then(com => com.RecipeForm),
        data: { title: 'New Color Recipe' },
    },
    {
        path: 'ink-kitchen/recipes/:id',
        loadComponent: () => import('./modules/ink-kitchen').then(com => com.RecipeDetail),
        data: { title: 'Color Recipe' },
    },
    {
        path: 'ink-kitchen/base-colors',
        loadComponent: () => import('./modules/ink-kitchen').then(com => com.BaseColorList),
        data: { title: 'Base Colors' },
    },
    {
        path: 'ink-kitchen/boards',
        loadComponent: () => import('./modules/ink-kitchen').then(com => com.BoardList),
        data: { title: 'Boards' },
    },
    {
        path: 'ink-kitchen/customers',
        loadComponent: () => import('./modules/ink-kitchen').then(com => com.PartyList),
        data: { title: 'Ink Kitchen Customers', kind: 'customer' },
    },
    {
        path: 'ink-kitchen/suppliers',
        loadComponent: () => import('./modules/ink-kitchen').then(com => com.PartyList),
        data: { title: 'Board Suppliers', kind: 'supplier' },
    },
    {
        path: 'production-data',
        component: ProductionDataView,
    },
    {
        path: 'production-data-add',
        component: ProductionDataAdd,
    }


];
